import React from 'react';
import { SmallBannerProps } from './SmallBanner.interface';
import { Image } from './SmallBanner.styles';

export function SmallBanner({ image }: SmallBannerProps) {
    return (
        <div>
            <Image src={image} alt='Small Banner' />
        </div>
    )
}
